'use client';

import { useEffect } from 'react';
import { useShopifyScript } from './useShopifyScript';

interface ShopifyScriptConfig {
  scriptUrl?: string;
  cssUrl?: string;
  buttonSelector?: string;
  autoLoad?: boolean;
  onScriptLoad?: () => void;
  onScriptError?: (error: Error) => void;
}

interface ShopifyScriptProps {
  config?: ShopifyScriptConfig;
}

export const ShopifyScript = ({ config = {} }: ShopifyScriptProps) => {
  const { autoLoad = true, ...hookConfig } = config;

  const { isLoaded, loadScript, reregisterButtons } =
    useShopifyScript(hookConfig);

  // Auto-load script if configured to do so
  useEffect(() => {
    if (autoLoad && !isLoaded) {
      loadScript();
    }
  }, [autoLoad, isLoaded, loadScript]);

  // Expose global API for backward compatibility
  useEffect(() => {
    (window as any)['ShopifyScriptLoader'] = {
      loadScript,
      reregisterButtons,
      isLoaded,
    };

    return () => {
      delete (window as any)['ShopifyScriptLoader'];
    };
  }, [loadScript, reregisterButtons, isLoaded]);

  // Renders nothing: the marketplace stylesheet is injected by loadScript, so
  // pages that never boot Shopify don't pay for it.
  return null;
};
